import gql from 'graphql-tag';

const CLOCK_EVENT_FRAGMENT = gql`
	fragment clockEvent on ClockEvent {
		id
		action
		actionName
		mode
		modeName
		capturedAt
		clientEventId
		kioskDeviceId
		kioskName
		photoLink
		photoHash
		qrNonce
		qrIssuedAt
		qrExpiresAt
		deputyEmployeeId
		deputySyncStatus
		deputySyncStatusName
		deputySyncError
		deputyTimesheetId
		deputySyncedAt
		metadata
		user {
			id
			firstname
			lastname
			username
			deputyEmployeeId
		}
	}
`;

export const CREATE_CLOCK_QR_TOKEN = gql`
	mutation createClockQrTokenMutation($input: CreateClockQrTokenInput!) {
		createClockQrToken(input: $input) {
			token
			nonce
			action
			issuedAt
			expiresAt
		}
	}
`;

export const CREATE_CLOCK_EVENT = gql`
	mutation createClockEventMutation($input: CreateClockEventInput!) {
		createClockEvent(input: $input) {
			...clockEvent
		}
	}
	${CLOCK_EVENT_FRAGMENT}
`;

export const RETRY_CLOCK_EVENT_DEPUTY_SYNC = gql`
	mutation retryClockEventDeputySyncMutation($id: ID!) {
		retryClockEventDeputySync(id: $id) {
			...clockEvent
		}
	}
	${CLOCK_EVENT_FRAGMENT}
`;

export const SUBSCRIBE_TO_CLOCK_EVENT_SCAN = gql`
	subscription clockEventScanSubscription($input: ClockEventScanSubscriptionInput!) {
		ClockEventScanSubscription(input: $input) {
			clockEvent {
				...clockEvent
			}
			shiftSummary {
				clockInAt
				clockOutAt
				workedMinutes
			}
		}
	}
	${CLOCK_EVENT_FRAGMENT}
`;

export const GET_CLOCK_FALLBACK_USERS = gql`
	query getClockFallbackUsersQuery($tenantId: ID, $query: String, $limit: Int) {
		getClockFallbackUsers(tenantId: $tenantId, query: $query, limit: $limit) {
			id
			firstname
			lastname
			username
			deputyEmployeeId
			deputyDisplayName
		}
	}
`;

export const GET_CLOCK_KIOSK_TENANTS = gql`
	query getClockKioskTenantsQuery {
		getClockKioskTenants {
			id
			name
			timezone
			region
		}
	}
`;

export const GET_MY_CLOCK_SHIFT_SUMMARY = gql`
	query getMyClockShiftSummaryQuery($clockOutEventId: ID) {
		getMyClockShiftSummary(clockOutEventId: $clockOutEventId) {
			clockInAt
			clockOutAt
			workedMinutes
		}
	}
`;

export const GET_MY_CLOCK_STATUS = gql`
	query getMyClockStatusQuery {
		getMyClockStatus {
			isClockedIn
			lastEventAction
			lastEventCapturedAt
		}
	}
`;

export const GET_MY_CLOCK_OUT_REMINDER_STATUS = gql`
	query getMyClockOutReminderStatusQuery {
		getMyClockOutReminderStatus {
			canConfirmReturnedToWarehouse
			returnedToWarehouseAt
			reminderDueAt
			reminderActive
		}
	}
`;

export const CONFIRM_RETURNED_TO_WAREHOUSE = gql`
	mutation confirmReturnedToWarehouseMutation {
		confirmReturnedToWarehouse {
			canConfirmReturnedToWarehouse
			returnedToWarehouseAt
			reminderDueAt
			reminderActive
		}
	}
`;

export const GET_MY_CLOCK_PASS_SCAN_STATE = gql`
	query getMyClockPassScanStateQuery($since: Date) {
		getMyClockPassScanState(since: $since) {
			clockEvent {
				...clockEvent
			}
			shiftSummary {
				clockInAt
				clockOutAt
				workedMinutes
			}
		}
	}
	${CLOCK_EVENT_FRAGMENT}
`;

export const GET_CLOCK_EVENTS = gql`
	query getClockEventsQuery(
		$page: Int!,
		$perPage: Int!,
		$sortBy: String!,
		$sortDirection: Int!,
		$filter: ClockEventPageFilter
	) {
		getClockEvents(
			page: $page,
			perPage: $perPage,
			sortBy: $sortBy,
			sortDirection: $sortDirection,
			filter: $filter
		) {
			items {
				...clockEvent
			}
			count
		}
	}
	${CLOCK_EVENT_FRAGMENT}
`;
